const config = {
  apiBaseUrl: process.env.NODE_ENV === 'production' 
    ? ''  // SWA serves API from same origin
    : 'http://localhost:3001'  // Local development
};

export default config;